module.exports = __webpack_public_path__ + "static/media/43.5abd93ca.jpg";